import styled from "styled-components";

export const FormItemContainer = styled.div`
    position: relative;
    margin-bottom: 1.5rem;
`;
